import { render } from "./CategorySegmentServiceForm.vue?vue&type=template&id=bc9e630e&scoped=true"
import script from "./CategorySegmentServiceForm.vue?vue&type=script&lang=js"
export * from "./CategorySegmentServiceForm.vue?vue&type=script&lang=js"

import "./CategorySegmentServiceForm.vue?vue&type=style&index=0&id=bc9e630e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9e630e"]])

export default __exports__